/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export * as assets from "./assets";
